import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {ItemWithChildrenStructure} from 'app/general/structures/ItemWithChildrenStructure';

import type {ReactNode} from 'react';

/* === KBTreeItemInnerButton */
type KBTreeItemInnerButtonProps = {
  toggleableIcon?: ReactNode;
  itemIcon?: ReactNode;
  isMillerColumn?: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
};
export const KBTreeItemInnerButton = ({
  children,
  toggleableIcon,
  itemIcon,
  isMillerColumn = false,
  onClick,
  className,
}: KBTreeItemInnerButtonProps) => (
  <button
    type="button"
    className={cs(
      'btn px-0 py-2 flex-grow-1 d-flex align-items-center text-left',
      className
    )}
    onClick={onClick}
  >
    {!isMillerColumn && toggleableIcon != null ? (
      <div className="kb-item-icon-container">{toggleableIcon}</div>
    ) : null}
    {itemIcon != null ? (
      <div className="kb-item-icon-container">{itemIcon}</div>
    ) : null}
    {children}
  </button>
);

/* === KBTreeItemInnerDiv */
type KBTreeItemInnerDivProps = {
  toggleableIcon?: ReactNode;
  itemIcon?: ReactNode;
  isMillerColumn?: boolean;
  children: ReactNode;
  className?: string;
  onClick?: any;
};
export const KBTreeItemInnerDiv = ({
  children,
  toggleableIcon,
  itemIcon,
  isMillerColumn = false,
  className,
}: KBTreeItemInnerDivProps) => (
  <div className={cs('px-0 flex-grow-1 d-flex align-items-center', className)}>
    {!isMillerColumn && toggleableIcon != null ? (
      <div className="kb-item-icon-container">{toggleableIcon}</div>
    ) : null}
    {itemIcon != null ? (
      <div className="kb-item-icon-container">{itemIcon}</div>
    ) : null}
    {children}
  </div>
);

/* === KBTreeCollapsibleItemStructure */
const StyledExpandibleDiv = styled.div`
  .tree-item-expandable.expanded {
    transform: rotate(90deg);
  }
`;
type Props = {
  icon: string | null;
  title: ReactNode;
  expanded: boolean;
  isMillerColumn?: boolean;
  disableToggleButton?: boolean;
  onToggleExpand: () => any;
  loading?: boolean;
  children?: ReactNode | null;
  actionsChildren?: ReactNode | null;
  additionalContent?: ReactNode;
  small?: boolean;
  active?: boolean;
};
export const KBTreeCollapsibleItemStructure = ({
  icon,
  title,
  expanded,
  children = null,
  loading,
  small,
  actionsChildren = null,
  onToggleExpand,
  disableToggleButton = false,
  isMillerColumn = false,
  additionalContent,
  active,
}: Props) => {
  const InnerComponent = disableToggleButton
    ? KBTreeItemInnerDiv
    : KBTreeItemInnerButton;
  return (
    <ItemWithChildrenStructure
      childrenClass={active ? 'bg-primary' : undefined}
      actionsChildren={actionsChildren}
      expandedChildren={expanded ? children : null}
    >
      <InnerComponent
        className={cs({
          'btn-sm': small,
          'text-white': active,
        })}
        isMillerColumn={isMillerColumn}
        toggleableIcon={
          !isMillerColumn && (
            <StyledExpandibleDiv>
              <i
                className={cs(
                  'tree-item-expandable fa-fw',
                  loading
                    ? 'fa fa-circle-notch fa-spin'
                    : 'fas fa-chevron-right',
                  {
                    expanded,
                  }
                )}
              />
            </StyledExpandibleDiv>
          )
        }
        onClick={() => onToggleExpand()}
      >
        {icon != null ? (
          <div className="kb-item-icon-container">
            <i className={icon} />
          </div>
        ) : null}{' '}
        {title}
      </InnerComponent>
      <div>{additionalContent != null ? additionalContent : null}</div>
    </ItemWithChildrenStructure>
  );
};
